import { useContext, useEffect } from "react";
import {
  Events,
  PAGES,
  TRACKING_CONTEXT,
  usePageTracking,
} from "modules/tracking";
import { useI18n } from "i18n";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { ArrowRightAlt } from "@remo-co/ui-core/src/icons/ArrowRightAlt";
import Avatar from "../../assets/avatar.svg";
import { styles } from "./styles";

interface Props {
  skipOnboarding: () => void;
  goToProfileSetup: () => void;
}

const UpdateProfilePrompt = ({
  skipOnboarding,
  goToProfileSetup,
}: Props): JSX.Element => {
  const { t } = useI18n(["common", "onboarding"]);
  const { track } = useContext(TRACKING_CONTEXT);

  usePageTracking(PAGES.ONBOARDING_PROFILE_PROMPT);

  const skipSteps = () => {
    track(Events.ATTENDEE_ONBOARDING_EJECTED);
    skipOnboarding();
  };

  useEffect(() => {
    track(Events.ATTENDEE_ONBOARDING_ABOUT_PROFILE_STEP);
  }, [track]);

  return (
    <Box data-testid="onboarding-screen-1" sx={styles.screenContainer}>
      <Box
        component="img"
        src={Avatar}
        alt="onboarding"
        sx={styles.onboardingAvatar}
      />
      <Box sx={styles.headerContainer}>
        <Typography aria-hidden variant="h3" sx={styles.heading}>
          {t("onboarding:profile.prompt")}
        </Typography>
      </Box>
      <Box sx={styles.onboardingControls}>
        <Button
          autoFocus
          aria-label={t("common:set.up.my.profile")}
          data-testid="setup-profile-button"
          variant="primary"
          sx={styles.nextButton}
          onClick={goToProfileSetup}
        >
          {t("common:set.up.my.profile")}
        </Button>
        <Button
          variant="ghost"
          color="blue"
          id="skip"
          data-testid="skip-button"
          aria-label={t("onboarding:accessibility.skip.onboarding")}
          onClick={skipSteps}
          sx={styles.textLinkBtn}
        >
          <Typography variant="h4" color="inherit" sx={styles.takeMeToEvent}>
            {t("onboarding:take.me.to.event")}
          </Typography>
          <ArrowRightAlt sx={styles.nextButtonIcon} />
        </Button>
      </Box>
    </Box>
  );
};

export default UpdateProfilePrompt;
